import {
  Box,
  Button,
  Typography,
  Dialog,
  Grid,
  Container,
  CssBaseline,
} from "@mui/material";
import { useEffect, useState } from "react";
import { validateItemInput } from "../../requests/validation/validateItemInput";
import { useNavigate } from "react-router-dom";
import {
  CustomBackdrop,
  ItemDetailsFormCommon,
  LoadingButtonText,
  ViewImage,
} from "../../common";
import { handleProcurementSaveEditedItem } from "./functions";

const initialValues = {
  sampleItemID: "",
  itemERPCode: "",
  itemDescription: "",
  specification: "",
  quantityForSample: "",
  preferredUnitOfMeasure: "",
  noOfSamplesRequired: "",
  productClass: "",
  productImage: { file: undefined, name: "" },
};
export function SampleRequestApprovalProcurementEditItemModal(props) {
  const history = useNavigate();
  // State to store loading state
  const [isSubmitting, setIsSubmitting] = useState(false);
  // State to store new product images to be uploaded
  const [productImagesNew, setProductImagesNew] = useState([]);
  // State to store existing product images
  const [existingProductImages, setExistingProductImages] = useState(
    props.data.requesterSampleImage ? props.data.requesterSampleImage : [],
  );

  // State for storing boolean for progress of image compression
  const [isCompressing, setIsCompressing] = useState(false);
  // State for storing timer for Secondary Message in CustomBackdrop
  const [patienceTimer, setPatienceTimer] = useState(false);
  // State to store any validation errors
  const [errors, setErrors] = useState();

  // State for storing form input values
  const [values, setValues] = useState({
    // Initial values for form fields
    ...initialValues,
  });

  let {
    sampleItemID,
    itemERPCode,
    itemDescription,
    specification,
    quantityForSample,
    preferredUnitOfMeasure,
    noOfSamplesRequired,
    productClass,
    dateModified,
    requesterSampleImage = [],
    ...dataRest
  } = props.data;

  // Effect to initialize form values when the modal opens based on props.data
  useEffect(() => {
    setIsSubmitting(false);
    setValues({
      sampleItemID: props.data.sampleItemID,
      itemERPCode: props.data.itemERPCode,
      itemDescription: props.data.itemDescription,
      specification: props.data.specification,
      quantityForSample: props.data.quantityForSample,
      preferredUnitOfMeasure: props.data.preferredUnitOfMeasure,
      noOfSamplesRequired: props.data.noOfSamplesRequired,
      productClass: props.data.productClass,
      productImage: props.data.requesterSampleImage,
    });
    setExistingProductImages(
      Array.isArray(props.data.requesterSampleImage)
        ? props.data.requesterSampleImage
        : [],
    );
  }, [props.data]);

  // Function to close the modal and reset form states
  const handleClose = () => {
    props.setOpen(false);
    setValues({
      ...initialValues,
    });
    setProductImagesNew([]);
    setExistingProductImages([]);
    setIsSubmitting(false);
  };

  // Handler for form input changes
  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  // Handler to remove an existing product image
  const handleImageRemove = (index) => {
    const updatedImages = [...existingProductImages];
    updatedImages.splice(index, 1);
    setExistingProductImages(updatedImages);
  };

  // Function to handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    const { validationErrors, isValid } = validateItemInput(values);
    !isValid && setErrors(validationErrors);
    isValid &&
      handleProcurementSaveEditedItem(
        setErrors,
        props,
        productImagesNew,
        setPatienceTimer,
        setIsCompressing,
        dataRest,
        values,
        existingProductImages,
        history,
        setValues,
        setIsSubmitting,
        handleClose,
        initialValues,
      );
  };

  errors && console.log({ errors });

  return (
    <div>
      {values && (
        <Dialog open={props.open} onClose={handleClose} {...DialogProps}>
          <Box
            sx={{
              display: props.display,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Container {...ContainerProps}>
              <Typography {...TypographyProps}>Edit Item</Typography>
              <CssBaseline />
              <Box {...FormBoxProps}>
                <ItemDetailsFormCommon
                  values={values}
                  onChange={onChange}
                  errors={errors}
                  productImage={productImagesNew}
                  setProductImage={setProductImagesNew}
                />
                {/* Display the product images present in the item details before editing§ */}
                {existingProductImages &&
                  Array.isArray(existingProductImages) &&
                  existingProductImages.map((imageObject, index) => (
                    <Grid container key={index}>
                      <Grid item xs={12}>
                        <ViewImage productImage={imageObject} />
                      </Grid>
                      {/* Remove button for removing an reference image§ */}
                      <Button
                        {...RemoveButtonProps}
                        onClick={() => handleImageRemove(index)}
                      >
                        Remove
                      </Button>
                    </Grid>
                  ))}

                <Grid {...ButtonGridProps}>
                  <Grid item>
                    <Button onClick={handleSubmit} {...SaveButtonProps}>
                      <LoadingButtonText loading={isSubmitting} text="Save" />
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </Box>
        </Dialog>
      )}
      <CustomBackdrop
        open={isCompressing}
        primaryMessage="Please wait: Compressing selected images"
        timer={patienceTimer}
        secondaryMessage="Larger images take longer to compress."
      />
    </div>
  );
}

const DialogProps = {
  style: {
    height: "90%",
  },
  PaperProps: { sx: { borderRadius: "10px" } },
};

const TypographyProps = {
  component: "h1",
  variant: "h5",
};

const ContainerProps = {
  component: "main",
  maxWidth: "sm",
  sx: {
    marginTop: 4,
    flexDirection: "column",
    alignItems: "center",
  },
};

const FormBoxProps = {
  component: "form",
  noValidate: true,
  sx: {
    mt: 5,
  },
};

const RemoveButtonProps = {
  sx: {
    mt: 3,
    mb: 3,
  },
  color: "error",
};

const ButtonGridProps = {
  container: true,
  spacing: 2,
  sx: {
    mt: 1,
    flexDirection: "row",
    justifyContent: "center",
  },
};

const SaveButtonProps = {
  variant: "contained",
  sx: {
    mt: 3,
    mb: 3,
    width: "150px",
  },
};
